import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'

interface IProps {
  isShown: boolean
  isSubTextHidden?: boolean
  type: string
  name: string
  onApply(): void
  onHide(): void
}

@observer
export default class DeleteDeliveryAttributeConfirmDialog extends React.Component<IProps> {
  public render() {
    const { isShown, onHide, onApply, type, name, isSubTextHidden } = this.props

    const capitalizedType =
      type && type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
    return (
      <ConfirmDialog
        isOpen={isShown}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        title={this.title}
        doneTitle="Delete"
        useRedConfirmationButton
      >
        <div className="tw:text-body-md">
          <div>
            Are you sure you want to delete the {capitalizedType}{' '}
            <span className="tw:font-bold">{name}</span>?
          </div>
          {!isSubTextHidden && (
            <>
              <div className="tw:mt-3 tw:font-bold">
                If you delete this {capitalizedType}:
              </div>
              <div className="tw:flex tw:flex-col tw:gap-1">
                <div className="tw:flex tw:gap-2">
                  <span>&#8226;</span>
                  <span>
                    It will no longer appear in Workflow forms fields or Map
                    views.
                  </span>
                </div>
                <div className="tw:flex tw:gap-2">
                  <span>&#8226;</span>
                  <span>
                    Future Workflows assigned to this {capitalizedType} will be
                    marked as "Requested" until a valid {capitalizedType} is
                    selected.
                  </span>
                </div>
                <div className="tw:flex tw:gap-2">
                  <span>&#8226;</span>
                  <span>
                    Historical Workflows referencing this {capitalizedType} will
                    remain visible in Reports.
                  </span>
                </div>
              </div>
              <div className="tw:mt-1 tw:font-bold">
                This action cannot be undone.
              </div>
            </>
          )}
        </div>
      </ConfirmDialog>
    )
  }

  private get title() {
    const { type } = this.props
    return `Confirm Deletion of ${type}`
  }
}
